export default "__VITE_ASSET__B3VR8R5V__"